import Input from '@talkdesk/cobalt-react-input'
import Button from '@talkdesk/cobalt-react-button'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'
import MFAHeader from '../MFAHeader'
import ErrorMessage from '../ErrorMessage'
import useMFA from '../../hooks/useMFA'
import { useTranslation } from 'react-i18next'

export const OTPForm = ({
  csrf,
  ctx,
  icon,
  iconColor,
  titleKey,
  labelKey,
  mfaType,
  fieldName,
  fieldId,
}) => {
  const { t } = useTranslation()
  const {
    code,
    showError,
    verifyButtonState,
    disabledForm,
    errorMessage,
    isVerifyButtonDisabled,
    handleCodeChange,
    doLogin,
  } = useMFA({
    invalidCodeErrorMessage: () => t(`${titleKey}.invalidError`),
    genericErrorMessage: () => t(`${titleKey}.genericError`),
  })

  const handleSubmit = () => {
    const mfa = {
      type: mfaType,
      payload: {
        [fieldName]: code,
      },
    }
    doLogin(csrf, ctx.credentials, mfa)
  }

  const label = t(labelKey)

  const stateProps = /** @type {any} */ ({ state: verifyButtonState })

  return (
    <>
      <MFAHeader
        icon={icon}
        iconColor={iconColor}
        title={t(`${titleKey}.title`)}
        subtitle={t(`${titleKey}.description`)}
      />
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        {showError ? <ErrorMessage message={errorMessage} /> : null}
        <div>
          <Label htmlFor={fieldId}>{label}</Label>
          <Box paddingTop={2} />
          <Input
            id={fieldId}
            autoFocus
            value={code}
            onChange={handleCodeChange}
            placeholder={label}
            type='text'
            inputMode='numeric'
            pattern='[0-9]*'
            disabled={disabledForm}
          />
        </div>
        <Box paddingTop={4} />
        <Button
          htmlType='submit'
          disabled={isVerifyButtonDisabled()}
          {...stateProps}
          type='primary'
          shape='full-width'
        >
          {t('mfa.verify')}
        </Button>
      </form>
    </>
  )
}

export default OTPForm
